export const SET_TARGET_REFERENCES = 'SET_TARGET_REFERENCES';